<template>
  <div v-if="resetting" />
  <div v-else>
    <label
      v-if="!hideLabels"
      class="replacement-label"
    >{{ label }}</label>
    <div
      class="form-row hide-label"
      :class="{'form-wrapper__error': hasError }"
    >
      <div
        v-for="option in options"
        :key="option.id"
        :class="inputsWrappingClass"
      >
        <div class="check-btn">
          <input
            :id="uniqueId(option)"
            type="radio"
            :value="option.id"
            :required="required"
            :class="buttonClasses(option)"
            :name="name"
            @input="updateValue"
            @change="changeValue"
            @blur="$emit('blur')"
          >
          <label :for="uniqueId(option)">{{ option.display_label }}</label>
        </div>
      </div>

      <div class="col-12">
        <p
          v-show="hasError"
          class="form__error"
        >
          {{ error }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  props: {

    // for survey
    hideLabels: {
      type: Boolean,
      default: false,
    },
    allowTwoStack: {
      type: Boolean,
      default: false,
    },
    forceFullWidthInputs: {
      type: Boolean,
      default: false,
    },

    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Form Label',
    },
    name: {
      type: String,
      default: 'form-name',
    },
    id: {
      type: String,
      default: 'form-id',
    },
    // disabled: {
    //   type: Boolean,
    //   default: false,
    // },
    required: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
      required: false,
    },

    options: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      resetting: false,
    };
  },
  computed: {
    inputsWrappingClass() {
      if (this.allowTwoStack && this.options.length === 2) {
        return 'col-12 col-sm-6';
      }

      if (!this.forceFullWidthInputs) {
        if (this.options.length === 5 || this.options.length === 6) {
          return 'col-12 col-md-2';
        }

        if (this.options.length === 4) {
          return 'col-12 col-md-3';
        }

        if (this.options.length === 3) {
          return 'col-12 col-md-4';
        }

        if (this.options.length === 2) {
          return 'col-12 col-md-6';
        }
      }

      return 'col-12';
    },
  },
  methods: {
    reset() {
      this.resetting = true;
      setTimeout(() => {
        this.resetting = false;
        // todo: fix this little transition on reset
        // set the same height and just fade in the new options ..
      }, 0);
    },
    buttonClasses(option) {
      if (this.value && option.id == this.value) {
        return 'input selected';
      }
      return 'input';
    },
    uniqueId(option) {
      return `chk_${this.name}_${option.id}`;
    },
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
    changeValue(e) {
      this.$emit('change', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .check-btn {
    label {
      @include border-radius($border-radius);

      position: relative;
      display: inline-block !important;
      width: 100%;
      max-width: 100%;
      height: 45px;
      margin-bottom: 15px;
      padding: 0;
      border: $default-border;
      cursor: text;
      background: rgba(33, 54, 75, 1);
      color: white;
      text-align: center;
      line-height: 45px;

      &:hover {
        cursor: pointer;
        background: $light-blue;
      }

      ::v-deep .btn {
        &:active,
        &.active,
        &:focus {
          outline: 0 !important;
        }
      }
    }

    input[type="radio"],
    input[type="checkbox"] {
      position: absolute;
    }

    input[type="radio"].selected + label,
    input[type="checkbox"].selected + label,
    .Checked + label {
      background: $green;
      border: solid 1px $green;
      color: $btn-color;
    }
  }

  .hide-label {
    ::v-deep label {
      display: none;
    }
  }

  .form-wrapper__error {
    input,
    label {
      border: solid 1px $red !important;
      outline: 0 !important;
      box-shadow: none !important;
    }

    .form__error {
      max-height: 200px;
      padding-bottom: 1rem;
      color: $red;
      transition: max-height 0.3s ease-out;
      position: relative;
      margin-top: -10px;
    }
  }
</style>
